import { createSelector } from 'reselect';
import { collapseInfoSectionSelector } from 'selectors/testTarget/offers/collapseInfoSection/collapseInfoSectionSelector';

const showSelector = createSelector(collapseInfoSectionSelector, collapseInfoSection => !!collapseInfoSection.show);

export { showSelector };
